/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_exercise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise (min/day)`)
};

const es_water_exercise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicio (min/día)`)
};

const de_water_exercise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training (Min./Tag)`)
};

const nl_water_exercise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beweging (min/dag)`)
};

const fr_water_exercise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice (min/jour)`)
};

const it_water_exercise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizio (min/giorno)`)
};

const pt_br2_water_exercise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício (min/dia)`)
};

const pt_water_exercise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício (min/dia)`)
};

const ja_water_exercise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`運動時間 (分/日)`)
};

const zh_water_exercise = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运动时长（分钟/天）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_exercise = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_exercise(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_exercise", locale)
	if (locale === "en") return en_water_exercise(inputs)
	if (locale === "es") return es_water_exercise(inputs)
	if (locale === "de") return de_water_exercise(inputs)
	if (locale === "nl") return nl_water_exercise(inputs)
	if (locale === "fr") return fr_water_exercise(inputs)
	if (locale === "it") return it_water_exercise(inputs)
	if (locale === "pt-BR") return pt_br2_water_exercise(inputs)
	if (locale === "pt") return pt_water_exercise(inputs)
	if (locale === "ja") return ja_water_exercise(inputs)
	return zh_water_exercise(inputs)
};